module.exports = __webpack_public_path__ + "static/media/SangBleuVersailles-Regular-WebM.285aa26a.ttf";